import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ColoredAlpineIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <path
            d="M16 21L14 18L8.27135 8.45225C8.15165 8.25275 7.86026 8.25952 7.74996 8.46436L1.23812 20.5578C1.1305 20.7576 1.27526 21 1.50227 21H16ZM14 18L17.2453 11.9729C17.3566 11.7662 17.6515 11.7617 17.7691 11.9648L22.7393 20.5497C22.8551 20.7497 22.7108 21 22.4797 21H16"
            strokeWidth="1.8"
            strokeLinecap="round"
            stroke="#262626"
          />
          <path
            d="M4 15.6119C5.5 14.4869 7.19251 15.0096 8.41377 16.3953C9.69096 17.8484 11.7228 17.751 13 16.3953"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M21.1 6C21.1 7.1598 20.1598 8.1 19 8.1C17.8402 8.1 16.9 7.1598 16.9 6C16.9 4.8402 17.8402 3.9 19 3.9C20.1598 3.9 21.1 4.8402 21.1 6Z"
            strokeWidth="1.8"
            stroke="#257FD8"
          />
        </>
      ) : (
        <>
          <circle cx="19" cy="6" r="3" fill="#257FD8" stroke="#257FD8" />
          <path
            d="M16 21L14 18L8.27135 8.45225C8.15165 8.25275 7.86026 8.25952 7.74996 8.46436L1.23812 20.5578C1.1305 20.7576 1.27526 21 1.50227 21H16ZM14 18L17.2453 11.9729C17.3566 11.7662 17.6515 11.7617 17.7691 11.9648L22.7393 20.5497C22.8551 20.7497 22.7108 21 22.4797 21H16"
            strokeWidth="1.8"
            strokeLinecap="round"
            stroke="#262626"
          />

          <path
            d="M4.00001 15.6119C4.01029 15.6042 3.98972 15.6194 4.00001 15.6119ZM4.00001 15.6119C6 15 7.20089 15.0191 8.41378 16.3953C9.69097 17.8484 11.7228 17.751 13 16.3953L8.00001 10L4.00001 15.6119Z"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            opacity="0.2"
            d="M5.5 14L8 11L12 16.5L11 17.5L5.5 14Z"
            fill="#257FD8"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default ColoredAlpineIcon;
